import type { ProviderProgressEntry } from "../../../hooks/useProviderProgress";
import type { StreamModelInfo } from "./types";

/** Extract the current model info from events for a specific stream */
export function extractModelInfo(
  events: ProviderProgressEntry[],
  streamId: string,
): StreamModelInfo | null {
  // Events are in chronological order (oldest first), iterate backwards for latest
  // First check for model:switched events (most recent model)
  for (let i = events.length - 1; i >= 0; i--) {
    const event = events[i];
    if (event.event_type === "model:switched" && event.stream_id === streamId) {
      const data = event.event_data;
      const to = typeof data.to === "string" ? data.to : null;
      if (to) {
        const reasoningEffort =
          typeof data.reasoningEffort === "string"
            ? data.reasoningEffort
            : null;
        return { currentModel: to, reasoningEffort };
      }
    }
  }

  // Fall back to model:selected event (initial model)
  for (let i = events.length - 1; i >= 0; i--) {
    const event = events[i];
    if (event.event_type === "model:selected" && event.stream_id === streamId) {
      const data = event.event_data;
      const mainModel =
        typeof data.mainModel === "string" ? data.mainModel : null;
      if (mainModel) {
        const reasoningEffort =
          typeof data.mainReasoningEffort === "string"
            ? data.mainReasoningEffort
            : null;
        return { currentModel: mainModel, reasoningEffort };
      }
    }
  }

  return null;
}
